module.exports = __webpack_public_path__ + "img/symbol_1.b0e40e28.png";